import { useSelector, useDispatch } from 'react-redux'

import { setAppLoading, setAppUpdated } from '@store/ducks/application'

export default function useLoading() {
  const dispatch = useDispatch()

  const { loading: isLoading, feature: featureLoading } = useSelector(
    store => store.application
  )

  function startLoad(featureToLoad) {
    dispatch(setAppLoading(featureToLoad))
  }

  function finishLoad() {
    dispatch(setAppUpdated())
  }

  return {
    isLoading,
    startLoad,
    finishLoad,
    featureLoading,
  }
}
